import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import { SalaryToBankTransferPopUp } from "./SalaryToBankTransferTable";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import moment from "moment";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import { permission } from "../../../utils/enums/ValidationMessage";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";

class SalaryToBankTransfer extends Component {
  constructor(props) {
    super(props);
    this.accountTransactionServices = new AccountTransactionServices();
    this.SwalServices = new SwalServices();
    this.state = {
      permissions: {
        isAddEdit: false,
        isDelete: false,
        isView: false,
      },
      urlId: 0,
      isModalOpen: false,
      isSaving: false,
      isTable2Expanded: false,
      prop: {},
      caption: "",
      colName: "",
      paginationPageSize: 50,
      rowHeight: 40,
      rowData: [],
      colDefs: [],
      table2Data: [],
      table2ColDefs: [],
      idCompany: 0,
      idUser: 0,
      employeeBasicDetails: {
        idSalaryToBank: 0,
        updateStatus: 0,
        voucherNo: "",
        date: "",
        idAccountHead: 0,
        idEmployeeSalary: 0,
        employeeSalaryNoList: [],
        employeeSalaryNoListForUpdate: [],
        //authorisedBy: "",
        fromDate: "",
        toDate: "",
        fromAccountId: "",
        //selectSeries: "",
        chequeNo: "",
        totalSalaryAmount: "",
        authorisedBy: 0,
        stdRowData: [],
        employeeList: [],
        accountheadList: [],
        masterEmployeeList: [],
        masterBankList: [],
        idChequeBookMaster: 0,
        seriesList: [],
        idChequeBookDetails: 0,
        chequeNoList: [],
        e_Date: "",
        dbIdCheck: 0,
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        date: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "date"
            ),
          },
        ],
        idEmployeeSalary: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "salary no"
            ),
          },
        ],
        authorisedBy: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "authorised by"
            ),
          },
        ],
      },
    };
  }

  isValidAllFieldsBasicDetails = () => {
    const newValidState = isValidForm(
      this.state.employeeBasicDetails,
      this.state.validationRules,
      this.state.validState,
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  }

  toggleExpandCollapseTable = (tableNumber) => {
    this.setState((prevState) => {
      if (tableNumber === 2) {
        return { isTable2Expanded: !prevState.isTable2Expanded };
      } else if (tableNumber === 3) {
        return { isTable3Expanded: !prevState.isTable3Expanded };
      } else {
        return {};
      }
    });
  };

  handleCellClick = (event) => {
    //if (event.colDef.field === "piQty") {
    //debugger
    this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Salary To Bank Transfer");
    //}
  };

  componentDidMount = () => {
    let params = new URLSearchParams(window.location.search);
    let id = params.get("id")
    if (id) {
      let urlId = decryptAES(id)
      if (urlId) {
        if (urlId != null) {
          this.setState({ urlId: urlId });
        }
      }
    }

    let prop = getAuthProps()
    //debugger
    if (prop.idCompany && prop.idCompany > 0) {
      this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
        this.procSelectAllRecordsSP();
        this.getSalaryToBankDropdown();
      });
    } else {
      // window.location.href = "/Login";
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
  };

  getSalaryToBankDropdown = () => {
    let request = {
      idCompany: this.state.idCompany,
      idFinancialYear: 2
    }
    this.accountTransactionServices.getSalaryToBankDropdown(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let dropDowndata = response.responseItem.responseContent;
        let data = this.state.employeeBasicDetails;

        data.employeeSalaryNoList = dropDowndata.filter(item => item.source === 'New_EmployeeSalaryStructured'); //designations.map((p) => ({ value: p.id, label: p.name }));
        data.employeeSalaryNoListForUpdate = dropDowndata.filter(item => item.source === 'Update_EmployeeSalaryStructured');
        data.employeeList = dropDowndata.filter(item => item.source === 'Master_Employee');
        data.accountheadList = dropDowndata.filter(item => item.source === 'Master_AccountHead');
        data.masterEmployeeList = dropDowndata.filter(item => item.source === 'Master_Employee');
        data.masterBankList = dropDowndata.filter(item => item.source === 'Master_Bank');

        // let voucherNo = dropDowndata.filter(item => item.source === 'EmployeeSalaryCount');
        // data.voucherNo = voucherNo?.[0].value > 0 ? (voucherNo?.[0].value + 1) : (0 + 1);
        //debugger;
        this.setState({
          employeeBasicDetails: data
        });
      }
    });
  }

  procSelectAllRecordsSP = () => {
    let request = {
      formname: "Salary To Bank Transfer",
      idCompany: this.state.idCompany,
      allowToRateVisible: 1,
      idUser: 0,
      //idFinancialYear : null,
      //idPlant : 0,
    };
    this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let permissions = response.responseItem.responseContent[0][0];
        this.setPermissions(permissions);
        if (permissions.view) {
          let data = response.responseItem.responseContent[1];
          if (data.length > 0) {
            const dynamicColDefs = Object.keys(data[0]).map((key) => ({
              field: key,
              headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
              flex: 1,
              filter: true,
              floatingFilter: true,
              minWidth: this.getColumnWidth(key),
              hide: ["idSalaryToBank"].includes(key),
              valueGetter: (params) => params.data[key],
              valueFormatter: key.includes("bankDate")
                ? (params) => {
                  if (!params.value) return "";
                  return moment(params.value).format("DD-MM-YYYY");
                }
                : undefined,
            }));
            var colName = dynamicColDefs[0].field;
            let id = data ? data[0][colName] : 0;
            this.setState({
              rowData: data,
              colDefs: dynamicColDefs,
              caption: "Salary To Bank Transfer",
              colName: colName
            }, () => {
              if (this.state.urlId) {
                this.openPopUpFromURLId(this.state.urlId)
              }
              this.procSelectAllRecord2GridviewSP(id, "Salary To Bank Transfer");
            });
          } else {
            this.setPermissions(permissions);
            if (this.gridApi) {
              this.gridApi.showNoRowsOverlay();
            }
          }
        } else {
          window.location.href = "/authentication/UnAuthorized";
        }
      }
    });
  }

  openPopUpFromURLId = (id) => {
    let details = this.state.employeeBasicDetails;
    details.idSalaryToBank = id;
    this.setState({ employeeBasicDetails: details }, () => {
      this.getDetailsByID(this.state.employeeBasicDetails.idSalaryToBank);
    });
  };

  setPermissions = (permissions) => {
    let data = this.state.permissions;
    data.isAddEdit = permissions.addEdit;
    data.isDelete = permissions.delete;
    data.isView = permissions.view;
    this.setState({ permissions: data });
  }

  getColumnWidth = (key) => {
    const columnWidths = {
      "sR.No": window.innerWidth * 0.04,
      "accountSubHead": window.innerWidth * 0.14,
      "salaryToBankNo": window.innerWidth * 0.06,
      "bankDate": window.innerWidth * 0.07,
      "bankName": window.innerWidth * 0.25,
      "chequeBookSeries": window.innerWidth * 0.11,
      "chequeNo": window.innerWidth * 0.05,
      "totalAmount": window.innerWidth * 0.06,
      "status": window.innerWidth * 0.06,
    };
    return columnWidths[key];
  };

  procSelectAllRecord2GridviewSP = (id, formname) => {
    //debugger;
    let request = {
      id: id,
      formname: formname,
      allowToRateVisible: 1,
      //idCompany: this.state.prop.idCompany
    }
    if (id > 0) {
      this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
        if (response.statusCode === 200 && response.responseItem !== null) {
          const dynamicData = response.responseItem.responseContent;
          if (dynamicData.length > 0) {
            const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
              field: key,
              headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
              flex: 1
            }));
            this.setState({
              table2Data: dynamicData,
              table2ColDefs: dynamicColDefs,
              isTable2Expanded: true
            });
          }
        }
      });
    }
  }

  getTransactionEmployeeSalaryByID = (id) => {
    this.accountTransactionServices.getTransactionEmployeeSalaryByID(id).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let res = response.responseItem.responseContent[0];
        if (res) {
          //data.netPayble = value.balanceAmount;
          let data = this.state.employeeBasicDetails;
          //data.idEmployeeSalary = res.idEmployeeSalary;
          //data.updateStatus = 1;
          //data.voucherNo = res.idEmployeeSalary;
          //data.date = res.salaryDate ? moment(res.salaryDate).format('YYYY-MM-DD') : "";
          data.idAccountHead = res.idAccountHead;
          data.fromDate = res.fromDate ? moment(res.fromDate).format('YYYY-MM-DD') : "";
          data.toDate = res.toDate ? moment(res.toDate).format('YYYY-MM-DD') : "";
          data.authorisedBy = res.authorisedBy;
          data.totalSalaryAmount = res.totalSalaryAmount;
          //data.accSubHeadId = res.idAccountHead;
          this.setState({
            employeeBasicDetails: data
            //isModalOpen: true
          });
          this.accountTransactionServices.getTransactionEmployeeSalaryDetailsByID(id).then((responseData) => {
            if (responseData.statusCode === 200 && responseData.responseItem !== null) {
              let value = responseData.responseItem.responseContent;
              let employeeBasicDetails = this.state.employeeBasicDetails;
              //debugger;
              let stdRowData = [];
              if (value.length > 0) {
                value.map((x) => {
                  //debugger;
                  let request = {
                    idEmployee: x.idEmployee,
                    employeeName: this.state.employeeBasicDetails.employeeList?.find(item => item.value === x.idEmployee)?.label,
                    fixedSalary: x.basicSalary,
                    monthlySalary: x.monthSalary,
                    loanBalance: x.balanceAmt,
                    deductAmount: x.deductAmount,
                    remarks: x.remarks,
                  }
                  stdRowData.push(request);
                });
                if (stdRowData.length > 0) {

                  employeeBasicDetails.stdRowData = stdRowData;

                }
                this.setState({ employeeBasicDetails: employeeBasicDetails });
              }
              //}
              //employeeSalaryDetails = data;
            }
          });

        }
      }
    });
  }

  usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = (id, updateStatus) => {
    let request = {
      idBank: id,
      updateStatus: updateStatus,
    };
    this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let data = response.responseItem.responseContent;
        data = data.map((x) => ({
          value: x.idChequeBookMaster,
          label: x.chequeBookSeries,
        }));
        let detail = this.state.employeeBasicDetails;
        detail.seriesList = data;
        //b//ankToBankDetail.mainSeriesList = data;
        this.setState({
          employeeBasicDetails: detail
        });
      }
    });
  }

  usp_Master_ChequeBookForCompanyToBankTransfer = (id, updateStatus) => {
    let request = {
      updateStatus: updateStatus,
      idChequeBookMaster: id,
      idSalaryToBank: this.state.employeeBasicDetails.idSalaryToBank
    };
    this.accountTransactionServices.usp_Master_ChequeBookForCompanyToBankTransfer(request).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let data = response.responseItem.responseContent;
        data = data.map((x) => ({
          value: x.idChequeBookDetails,
          label: x.chequeNo,
        }));
        let detail = this.state.employeeBasicDetails;
        detail.chequeNoList = data;
        //b//ankToBankDetail.mainSeriesList = data;
        this.setState({
          employeeBasicDetails: detail
        });
      }
    });
  }

  getDetailsByID = (id) => {
    this.accountTransactionServices.getTransaction_CompanyToBankTransferSelectbyID(id).then((response) => {
      if (response.statusCode === 200 && response.responseItem !== null) {
        let res = response.responseItem.responseContent[0];
        if (res) {
          //data.netPayble = value.balanceAmount;
          let data = this.state.employeeBasicDetails;
          data.idSalaryToBank = res.idSalaryToBank;
          data.voucherNo = res.salaryToBankNo;
          data.updateStatus = 1;
          data.date = moment(res.bankDate).format('YYYY-MM-DD');
          data.idAccountHead = res.idAccountHead;
          data.idEmployeeSalary = data.employeeSalaryNoListForUpdate?.find(item => item.label === res.salaryToBankNo)?.value; //res.idEmployeeSalary;
          data.fromDate = moment(res.fromDate).format('YYYY-MM-DD');
          data.toDate = moment(res.toDate).format('YYYY-MM-DD');
          data.fromAccountId = res.idBank;
          data.totalSalaryAmount = res.totalSalaryAmount;
          data.authorisedBy = res.idAuthorisedBy;
          data.stdRowData = [];
          // data.employeeList = [];
          // data.accountheadList = [];
          data.employeeSalaryNoList = [];
          data.employeeSalaryNoList = data.employeeSalaryNoListForUpdate;
          //data.masterEmployeeList = [];
          // data.masterBankList = [];
          data.idChequeBookMaster = res.idChequeBookMaster;
          //data.seriesList = [];
          data.idChequeBookDetails = res.idChequeBookDetails;
          //data.chequeNoList = [];
          data.e_Date = res.e_Date;
          data.dbIdCheck = res.idChequeBookDetails
          this.setState({
            employeeBasicDetails: data,
            isModalOpen: true
          });

          this.accountTransactionServices.getTransaction_CompanyToBankTransferDetailsSelectbyID(id).then((responseData) => {
            if (responseData.statusCode === 200 && responseData.responseItem !== null) {
              let resList = responseData.responseItem.responseContent;
              let employeeBasicDetail = this.state.employeeBasicDetails;
              //debugger;
              if (resList.length > 0) {
                let salaryItemList = [];
                resList.map((x) => {
                  let request = {
                    idEmployee: x.idEmployee,
                    employeeName: employeeBasicDetail.employeeList?.find(item => item.value === x.idEmployee)?.label,
                    monthlySalary: x.monthSalary,
                    fixedSalary: x.fixedSalary,
                    balanceAmt: x.balanceAmt,
                    deductAmount: x.deductAmount,
                    remarks: x.remarks,
                  }
                  salaryItemList.push(request);
                });
                employeeBasicDetail.stdRowData = salaryItemList;
                this.setState({ employeeBasicDetails: employeeBasicDetail });
              }
              //}
              //employeeSalaryDetails = data;
            }
          });
          this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(res.idBank, 1);
          this.usp_Master_ChequeBookForCompanyToBankTransfer(res.idChequeBookMaster, 1);
        }

      }
    });
  }

  closePopup = () => {
    if (this.state.urlId) {
      this.setState({ route: '/ledger-report' });
    } else {
      this.setState({ isModalOpen: false, });
    }
  };

  submit = () => {
    // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
    if (this.isSubmitting) {
      return;
    }
    const isValidAllFields = this.isValidAllFieldsBasicDetails();
    if (isValidAllFields) {
      if (!this.state.employeeBasicDetails) {
        this.SwalServices.Error("Please add salary details.");
      } else {
        let details = this.state.employeeBasicDetails;
        // let details2 = this.state.salaryRowData;
        // let y = this.state.employeeSalaryDetails;
        let salaryItemList = [];
        details.stdRowData.map((x) => {
          let request = {
            idEmployee: x.idEmployee,
            monthlySalary: x.monthlySalary,
            fixedSalary: x.fixedSalary,
            balanceAmt: x.loanBalance,
            deductAmount: x.deductAmount,
            remarks: x.remarks,
          }
          salaryItemList.push(request);
        });
        if (details !== "") {
          let requestData = {
            idSalaryToBank: details.idSalaryToBank,
            updateStatus: details.updateStatus,
            salaryToBankNo: details.idEmployeeSalary > 0 ? details.employeeSalaryNoList?.find(item => item.value === details.idEmployeeSalary)?.label : "",
            bankDate: (details.date !== 'Invalid date' ? details.date : ''),
            idAccountHead: details.idAccountHead,
            idBank: details.fromAccountId,
            fromDate: details.fromDate,
            toDate: details.toDate,
            referenceNo: 0,
            idChequeBookDetails: details.idChequeBookDetails,
            idChequeBookMaster: details.idChequeBookMaster,
            remarks: 0,
            idCompany: this.state.idCompany,
            e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
            e_IDUser: this.state.idUser,
            isUpdated: details.updateStatus,
            updatedDate: details.updateStatus === 1 ? new Date().toISOString() : "",
            u_IDUser: details.updateStatus === 1 ? this.state.idUser : 0,
            isDeleted: 0,
            deletedDate: "",
            d_IDUser: "",
            totalSalaryAmount: details.totalSalaryAmount,
            idEmployeeSalary: details.idEmployeeSalary,
            idAuthorisedBy: details.authorisedBy,
            dbIdChecque: details.dbIdCheck,
            employeeSalaryDetailList: salaryItemList
          }
          this.isSubmitting = true;
          this.setState({ isSaving: true });
          this.accountTransactionServices.getTransaction_CompanyToBankTransferInsertUpdate(requestData)
            .then((response) => {
              if (response.statusCode === 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData !== null) {
                  if (this.state.employeeBasicDetails.updateStatus === 1) {
                    this.SwalServices.Success("Updated successfully.");
                  } else {
                    this.SwalServices.Success("Saved successfully.");
                  }
                  if (this.state.urlId) {
                    this.setState({ route: '/ledger-report' });
                  }
                  this.resetDetailsFields();
                  // Call resetFields here after submission
                  this.setState(
                    { isModalOpen: false },
                    () => {
                      this.procSelectAllRecordsSP(); // Fetch latest records
                    }
                  );
                } else {
                  this.procSelectAllRecordsSP();
                }
              } else {
                this.setState(
                  { isModalOpen: false },
                  () => {
                    this.SwalServices.Error(response.message);
                    this.procSelectAllRecordsSP(); // Fetch latest records
                  }
                );
              }
            }).finally(() => {
              this.isSubmitting = false;
              this.setState({ isSaving: false });
            });
        }
      }
    }
  }

  resetDetailsFields = () => {
    let reset = this.state.employeeBasicDetails;
    reset.idSalaryToBank = 0;
    reset.updateStatus = 0;
    reset.voucherNo = "";
    reset.date = "";
    reset.idAccountHead = 0;
    reset.idEmployeeSalary = 0;
    //reset.employeeSalaryNoList = [];
    reset.fromDate = "";
    reset.toDate = "";
    reset.fromAccountId = "";
    //reset.//selectSeries = "";
    //reset.chequeNo = "";
    reset.totalSalaryAmount = "";
    reset.authorisedBy = 0;
    reset.stdRowData = [];
    //reset.employeeList = [];
    //reset.accountheadList = [];
    //reset.masterEmployeeList = [];
    //reset.masterBankList = [];
    reset.idChequeBookMaster = 0;
    reset.seriesList = [];
    reset.idChequeBookDetails = 0;
    reset.chequeNoList = [];
    reset.e_Date = "";
    reset.dbIdCheck = 0;
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    this.setState({ employeeBasicDetail: reset, validState: validState }, () => {
      this.getSalaryToBankDropdown();
    });
  }

  onRowDoubleClicked = (event) => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.edit);
      return;
    }
    this.getDetailsByID(event.data.idSalaryToBank);
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    this.setState({ validState: validState })
  };

  setOpenModel = () => {
    if (this.state.urlId) {
      this.setState({ route: '/ledger-report' });
    }
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };
  openPopUpForAddingItem = () => {
    if (!this.state.permissions.isAddEdit) {
      this.SwalServices.Error(permission.add);
      return;
    }
    this.resetDetailsFields();
    this.setState({ isModalOpen: true })
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.employeeBasicDetails;
    details[name] = value;
    this.setState({ employeeBasicDetails: details });
  }
  handleSelectChange = (event, name) => {
    let select = event.target.value;
    let details = this.state.employeeBasicDetails;
    details[name] = select;
    this.setState({ employeeBasicDetails: details });
  }

  handleChangeFroDropdown = (event, name) => {
    //debugger;
    let value = event.value;
    //if (name === 'idEmployee') {
    let details = this.state.employeeBasicDetails;
    details[name] = value;
    this.setState({ employeeBasicDetails: details }, () => {
      //debugger;
      if (name === "idChequeBookMaster") {
        this.usp_Master_ChequeBookForCompanyToBankTransfer(value, this.state.employeeBasicDetails.updateStatus);
      } else if (name === "fromAccountId") {
        let data = this.state.employeeBasicDetails;
        data.chequeNoList = [];
        data.idChequeBookDetails = 0;
        data.seriesList = [];
        data.idChequeBookMaster = 0;
        this.setState({
          employeeBasicDetails: data
        }, () => {
          this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(value, this.state.employeeBasicDetails.updateStatus);
        })
      }
      else if (name === 'idEmployeeSalary') {
        this.getTransactionEmployeeSalaryByID(value);
      }
    });
    //} else {
    //   let details = this.state.employeeBasicDetails;
    //   details[name] = value;
    //   this.setState({ employeeBasicDetails: details });
    // }
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className='salary-bank-transfer'>
        <div className="data-display">
          <div className="data-display-inner relative">
            <ButtonGrp buttons={['add', 'print', 'delete']}
              onClickHandlers={{
                add: () => this.openPopUpForAddingItem(),
                // update: this.handleSave,
                print: this.handlePrint,
                delete: this.handleDelete,
              }}
            />
            <SalaryToBankTransferPopUp
              isModalOpen={this.state.isModalOpen}
              setOpenModel={this.setOpenModel.bind(this)}
              handleChange={this.handleChange.bind(this)}
              handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
              handleSelectChange={this.handleSelectChange.bind(this)}
              submit={this.submit.bind(this)}
              isSaving={this.state.isSaving}
              employeeBasicDetails={this.state.employeeBasicDetails}
              validState={this.state.validState}
              close={this.closePopup.bind(this)}
            />
            <div className="table w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                <div className="table-inner">
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Salary to bank transfer</h1>
                </div>
                <AgGridReact
                  rowData={this.state.rowData}
                  rowHeight={this.state.rowHeight}
                  columnDefs={this.state.colDefs}
                  pagination={true}
                  paginationPageSize={this.state.paginationPageSize}
                  onCellClicked={this.handleCellClick}
                  onRowDoubleClicked={this.onRowDoubleClicked}
                  onGridReady={this.onGridReady}
                  overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                  overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                />
              </div>
            </div>
            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
              <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                  <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                </div>
                <AgGridReact
                  rowData={this.state.table2Data}
                  columnDefs={this.state.table2ColDefs}
                  rowHeight={this.state.rowHeight}
                  pagination={true}
                  paginationPageSize={this.state.paginationPageSize}
                //onGridReady={this.state.onGridReady}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default SalaryToBankTransfer;